// @need-translate
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {PcGnbMenuItemProps} from './PcGnbMenuItemProps.interface';

export function PcGnbMenuItem({
  title,
  isSelected,
  onMouseEnter,
  onMouseLeave,
  onClick,
  className,
  ...props
}: PcGnbMenuItemProps) {
  return (
    <Text
      className={twMerge(
        'font-medium1-bold cursor-pointer select-none py-4px text-theme-solid-100 use-gpu hover:border-b-2 hover:border-b-theme-solid-100 hover:pb-2px',
        isSelected && 'border-b-2 border-b-theme-solid-100 pb-2px',
        className
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      {...props}
    >
      {isSelected && <Text className="blind">선택됨, </Text>}
      {title}
      <Text className="blind">탭, </Text>
    </Text>
  );
}
